import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from 'v5/design-system/Input';
import { useFieldContext } from 'v5/patterns/forms/schema-form/FieldContext';
import { FieldControlBase } from 'v5/patterns/forms/schema-form/fields/FieldControlBase';
import type { FieldComponent } from 'v5/patterns/forms/schema-form/fields/fieldComponent.types';

/** A boolean as the word the legacy view showed ("Yes" / "No"), not the form's tri-state toggle. */
export const ShortlistYesNoField: FieldComponent<'boolean'> = ({
  spec,
  path,
  hideLabel
}) => {
  const { t } = useTranslation('ds');
  const ctx = useFieldContext();
  const value = useWatch<Record<string, boolean | null>>({ name: path });
  return (
    <FieldControlBase spec={spec} hideLabel={hideLabel}>
      <Input
        readOnly
        variant={ctx.variant}
        size={ctx.size}
        value={value ? t('TernaryToggle.yes') : t('TernaryToggle.no')}
      />
    </FieldControlBase>
  );
};
